import { useSelector } from 'react-redux'

import { Roles } from 'clickNgo/configs/roles'
import { selectUser } from 'core-components/sitebuilder/store/selectors/selectUser'

export const useCheckCCDeveloperAccess = () => {
  const user = useSelector(selectUser)

  return user.roleIds.includes(Roles.CC_DEVELOPER)
}
